import React from "react";
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';

const KycRequirement = (props) => {
    return (
        <div>
            <Typography variant='h6' mt={6}>
                Document  required for assignment
            </Typography>
            <Grid container spacing={2} py={2}>
                <Grid item size={6} py={1}>
                    <div style={{alignItems:'center', display:'flex'}}>
                        <img src="/images/pan-card.png" style={{width:56, height:32}} />
                        <Typography mx={2} variant='body2'>PAN Card</Typography>
                    </div>
                </Grid>
                <Grid item size={6} py={1}>
                    <div style={{alignItems:'center', display:'flex'}}>
                        <img src="/images/aadhaar.png" style={{width:56, height:32}} />
                        <Typography mx={2} variant='body2'>Aadhaar</Typography>
                    </div>
                </Grid>
                <Grid item size={6} py={1}>
                    <div style={{alignItems:'center', display:'flex'}}>
                        <img src="/images/bank-details.png" style={{width:56, height:32}} />
                        <Typography mx={2} variant='body2'>Bank Details</Typography>
                    </div>
                </Grid>
                <Grid item size={6} py={1}>
                    <div style={{alignItems:'center', display:'flex'}}>
                        <img src="/images/webcam.png" style={{width:56, height:32}} />
                        <Typography mx={2} variant='body2'>Web cam</Typography>
                    </div>
                </Grid>
            </Grid>
        </div>
    )
}

export default KycRequirement;
